import React from "react";
import PropTypes from "prop-types";
import { Button } from "cxa-components";
import { AlertModal } from "@cxagroup/casper";
import { intlShape, injectIntl } from "react-intl";
import messages from "components/messagesDescription";

const CancelDialog = props => {
  const {
    isOpen,
    activityName,
    activityId,
    signUpCode,
    closeDeleteItemModal,
    removeActivity,
    intl,
  } = props;
  return (
    <AlertModal
      isOpen={isOpen}
      title=""
      body={intl.formatMessage(messages.removeActivityDescription, {
        activityName,
      })}
      footer={
        <div>
          <Button primary type="button" onClick={() => removeActivity(activityId, signUpCode)}>
            {intl.formatMessage(messages.confirmTextDescription)}
          </Button>
          <Button secondary type="button" onClick={closeDeleteItemModal}>
            {intl.formatMessage(messages.cancelDescription)}
          </Button>
        </div>
      }
    />
  );
};

CancelDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  activityName: PropTypes.string.isRequired,
  activityId: PropTypes.number.isRequired,
  signUpCode: PropTypes.string,
  closeDeleteItemModal: PropTypes.func.isRequired,
  removeActivity: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(CancelDialog);



// WEBPACK FOOTER //
// ./components/wellness/activities/CancelDialog.js